export default {
  async fetch () {
    await this.$store.dispatch('util/init')
  }
}
